export enum AppScreen {
    Progress = 'progress',
    Moves = 'moves',
    Assets = 'assets',
    Journal = 'journal',
    Oracles = 'oracles'
}